var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZenterprizeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.85592C0 2.17407 2.11505 0 4.72409 0H37.3039C41.5547 0 43.6429 5.31993 40.5823 8.35217L8.00251 40.6307C5.00232 43.6031 0 41.4176 0 37.1344V4.85592Z",
    fill: "#2496FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0164 22.9846C18.0164 20.2317 20.2006 18 22.895 18H43.1547C47.5404 18 49.6989 23.4522 46.5465 26.5675L26.2868 46.5884C23.1907 49.6479 18.0164 47.4063 18.0164 43.0055V22.9846Z",
    fill: "#31ECE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenterprizeLogo);
export default __webpack_public_path__ + "static/media/zenterprize-logo.136115d42889c46a6a8563e9e5279183.svg";
export { ForwardRef as ReactComponent };